// @ vendors
const React = require('react');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ constants
const TRANSFERS_AGENDA_ADD_BENEFICIARY_LINK = `/myprofile/transfers/agenda/addBeneficiary`;
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');

class TransfersAgendaEmptyState extends React.Component {
    render() {
        const emptyStateButtonBlock = (
            <OKButton
                modifier="secondary"
                to={TRANSFERS_AGENDA_ADD_BENEFICIARY_LINK}
            >
                <FormattedText value="transfersLanding-noTransfersBeneficiariesButtonLabel" />
            </OKButton>
        );

        return (
            <EmptyState
                primaryText={formatText('transfersLanding-noTransfersBeneficiaries')}
                button={emptyStateButtonBlock}
                iconType="transfer-banking" />
        );
    }
}

module.exports = TransfersAgendaEmptyState;
